import { forwardRef, memo } from 'react';
import type { SchedulePrintLayout, SchedulePrintModel } from './schedulePrintModel';
import { SchedulePrintCourtMap } from './SchedulePrintCourtMap';
import { SchedulePrintMatchList } from './SchedulePrintMatchList';
import './SchedulePrintDocument.scss';

type SchedulePrintDocumentProps = {
  model: SchedulePrintModel;
  layout: SchedulePrintLayout;
};

export const SchedulePrintDocument = memo(
  forwardRef<HTMLDivElement, SchedulePrintDocumentProps>(function SchedulePrintDocument(
    { model, layout },
    ref
  ) {
    const pageClass =
      layout === 'list'
        ? ' schedule-print-document--landscape schedule-print-document--list'
        : model.usePortrait
          ? ' schedule-print-document--portrait'
          : model.useLandscape
            ? ' schedule-print-document--landscape'
            : '';

    const mapOrientationClass =
      layout === 'map' && model.mapDays[0]?.orientation === 'timeOnY'
        ? ' schedule-print-document--map-time-vertical'
        : '';

    return (
      <div ref={ref} className={`schedule-print-document${pageClass}${mapOrientationClass}`}>
        {layout === 'map'
          ? model.mapDays.map((day, index) => (
              <SchedulePrintCourtMap key={`${day.dayKey}-${day.rangeLabel}-${index}`} day={day} />
            ))
          : null}
        {layout === 'list'
          ? model.listDays.map((day) => <SchedulePrintMatchList key={day.dayKey} day={day} />)
          : null}
      </div>
    );
  })
);
